import {
  iamAccountEntityRaw,
  IAMAccountEntityRaw
} from "@youm-front/iam-account/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class IAMAccountCreateResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountCreateResponseDTO.validationSchema()
  );

  constructor(readonly data: IAMAccountCreateResponseDTORaw) {
    JsonSchemaValidator.validate(IAMAccountCreateResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["account"],
      properties: {
        account: iamAccountEntityRaw
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountCreateResponseDTORaw {
  account: IAMAccountEntityRaw;
}
